@let cItem = content();
@if (cItem) {
  <div class="pv3-track-info flex mt-2 pb-1">
    @if (showAlbumArt()) {
      <div class="album-art mr-2 sm:mr-3 w-16 h-16 md:w-24 md:h-24">
        @if (albumArtUrl()) {
          <img [src]="albumArtUrl()" alt="Album Artwork" />
        }
      </div>
    }
    <div class="play-info">
      @if (showPlayTime() && startedAt()) {
        <div class="played-at-time text-xs">
          {{ startedAtFormatted() }}
        </div>
      }
      <div class="metadata-wrapper">
        @if (cItem.contentType === 'MicBreak') {
          <div class="title-and-performer font-semibold">
            <div class="performer-name">Air Break</div>
          </div>
        } @else {
          <div class="title-and-performer">
            <span class="track-name font-semibold">{{ cItem.name }}</span>
            @if (cItem.performerName) {
              <span class="divider text-sm"> -by- </span>
              <span class="performer-name">{{ cItem.performerName }}</span>
            }
          </div>
          <div class="release-name text-sm sm:text-base">
            {{ cItem.releaseName }}
          </div>
          <div class="label text-sm">
            @if (cItem.releaseDate) {
              {{ cItem.releaseDate | slice: 0 : 4 }}
              @if (cItem.labelName) {
                -
              }
            }
            {{ cItem.labelName }}
          </div>
        }
      </div>
    </div>
  </div>
}
